import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _Entailment } from "../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { SelectTypeProcees } from "../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { _SignAndApprovalitem, _SignAndApprovalPanel } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../theme/Component/BasicButton";
import { EditorSignAndApprovalPanel } from "./EditorSignAndApprovalPanel";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectFunctionalArea } from "../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";

interface Props {
    IDSignAndApprovalPanel: number;
}

export const Verfirmas = ({ IDSignAndApprovalPanel }: Props) => {

    const { instance, setBean, bean, lista, setLista, handleChange, update } = useDataBean(_SignAndApprovalitem);
    const single = Singleton.getInstance();

    const [verfirmas, setVerfirmas] = useState<any>({ name: 'Firmas', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDSignAndApprovalPanel])

    const getLista = () => {
        instance.getSignAndApprovalItemCatalog(IDSignAndApprovalPanel).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        setBean({
            IDSignAndApprovalPanel: IDSignAndApprovalPanel,
            RequiresSign: true,
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        instance.updateSignAndApprovalItem(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const deleteItem = () => {
        instance.deleteSignAndApprovalItem(bean.IDSignAndApprovalItem).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => { console.log(err) })
    }

    const head = [
        { title: 'ID', property: 'IDSignAndApprovalItem', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Título de Firma', property: 'Title', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Funcionario', property: 'AccountName', visible: true },
        { title: 'Requerir Acción de Firma', property: 'RequiresSign', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Orden de Flujo de Aprobación', property: 'ApprovalOrder', visible: true },
        { title: 'Línea Plantilla', property: 'RowNumber', visible: true },
        { title: 'Columna Plantilla', property: 'ColumnNumber', visible: true },
        { title: 'Area Funcional/Plaza Laboral', property: 'FunctionalAreaName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Ver Firmas">
            <div className="row">

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Título de Firma</label>
                                <input type="text" name="Title" className="form-control" value={bean.Title} onChange={handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={bean.Code} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <EditorSignAndApprovalPanel label='Tipo' idSelector={bean.Type} onChange={(e: any) => { setBean({ ...bean, "Type": e }) }} />
                            </div>
                            {bean.Type === 0 && (
                                <div className="col-md-6">
                                    <AccountEditor
                                        idAccount={null}
                                        label="Empleado"
                                        onChange={(e) => {
                                            setBean({ ...bean, "IDAccount": e.IDAccount });
                                        }}
                                    />
                                </div>
                            )}
                            {bean.Type === 1 && (
                                <div className="col-md-6">
                                    <SelectFunctionalArea
                                        value={bean.IDLnFunctionalArea}
                                        label="Plaza"
                                        onChange={(e) => {
                                            setBean({ ...bean, "IDLnFunctionalArea": e.IDLn });
                                        }}
                                    />
                                </div>
                            )}
                            {/* <div className="col-md-6">
                                <AccountEditor idAccount={null} label="Empleado" onChange={(e) => { verfirmascrud.setBean({ ...verfirmascrud.bean, "IDAccount": e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectFunctionalArea value={verfirmascrud.bean.IDLnFunctionalArea} label="Plaza" onChange={(e) => { verfirmascrud.setBean({ ...verfirmascrud.bean, "IDLnFunctionalArea": e }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <label>Orden de Flujo de Aprobación</label>
                                <input type="text" name="ApprovalOrder" className="form-control" value={bean.ApprovalOrder} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Línea Plantilla</label>
                                <input type="text" name="RowNumber" className="form-control" value={bean.RowNumber} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Columna Plantilla</label>
                                <input type="text" name="ColumnNumber" className="form-control" value={bean.ColumnNumber} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Requerir Acción de Firma" estado={bean.RequiresSign} eventChange={(e: any) => {
                                    setBean({ ...bean, "RequiresSign": e });
                                }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={modalC} eventModal={deleteItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <p>Eliminar el registo {bean.Title}</p>
                            </div>
                        </div>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}